import routesObject from "../routesObject";

import CUSTOMER_STATUSES from "./CUSTOMER_STATUSES";

type RoutePropertyType = "url" | "key";

export default (routeProperty: RoutePropertyType = "url") => ({
  [CUSTOMER_STATUSES.new]: routesObject.otp[routeProperty],
  [CUSTOMER_STATUSES.preRegistered]: routesObject.addressDetails[routeProperty],
  [CUSTOMER_STATUSES.registered]: routesObject.bankCredentials[routeProperty],
  [CUSTOMER_STATUSES.systemApproved]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.declined]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.securityChecked]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.internalCollection]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.externalCollection]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.processCollection]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.demand]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.reclamation]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.fraud]: routesObject.dashboard[routeProperty],
  [CUSTOMER_STATUSES.legalCollection]: routesObject.dashboard[routeProperty]
});
